import script from "./SkeletAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletAvatar.vue?vue&type=script&setup=true&lang=js"

import "./SkeletAvatar.vue?vue&type=style&index=0&id=5527d486&lang=scss"

const __exports__ = script;

export default __exports__